import React, { Component, createRef, lazy } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { LbxPopup as LbxPopupComponent } from './LbxPopup.component';
import { LbxPopupFooter } from './LbxPopupFooter.component';

export const LbxWrapper = lazy(() => import(
    /* webpackMode: "lazy", webpackChunkName: "bookstores" */
    'Component/LbxWrapper'
));

export const CartDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/Cart/Cart.dispatcher'
);

export const mapDispatchToProps = (dispatch) => ({
    resetToast: () => CartDispatcher.then(
        ({ default: dispatcher }) => dispatcher.resetToast(dispatch)
    )
});
export const mapStateToProps = (state) => {
    const { lbx_popups_enabled } = state.ConfigReducer;
    const cart = state.CartReducer;

    return {
        lbx_popups_enabled,
        cart
    };
};
class LbxPopupContainer extends Component {
    static propTypes = {
        resetToast: PropTypes.func.isRequired,
        lbx_popups_enabled: PropTypes.string,
        cart: PropTypes.shape({
            cartTotals: PropTypes.shape({
                items: PropTypes.array,
                total_quantity: PropTypes.number
            }),
            toast: PropTypes.oneOfType([PropTypes.nullable, PropTypes.object])
        })
    }

    constructor(props) {
        super(props);
        this.dialogRef = createRef();
    }

    onCloseHandler() {
        const { current: dialog } = this.dialogRef;

        dialog.classList.add('closing');

        setTimeout(() => {
            dialog.classList.remove('closing');
            dialog.close();
        }, 500);
    }

    componentDidMount() {
        if (this.getIsDisabled()) return null;

        const { current: dialog } = this.dialogRef;

        if (dialog) {
            dialog.addEventListener('click', this.clickOutsideHandler.bind(this));
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { resetToast } = this.props;

        if (this.getIsDisabled()) return null;

        const { cart: { toast, cartTotals: { total_quantity} } } = this.props || {};
        const { cart: { cartTotals: { total_quantity:  prevTotal_quantity } } } = prevProps || {};

        if (prevTotal_quantity === 0 && total_quantity > 0 && toast !== null) {
            this.handleProductAdded();
            resetToast();
        }
    }

    clickOutsideHandler(e) {
        const { current: dialog } = this.dialogRef;
        const dialogDimensions = dialog.getBoundingClientRect()

        if (
            e.clientX < dialogDimensions.left ||
            e.clientX > dialogDimensions.right ||
            e.clientY < dialogDimensions.top ||
            e.clientY > dialogDimensions.bottom
        ) {
            this.onCloseHandler();
        }
    }

    closeAfterTimeout() {
        const { current: dialog } = this.dialogRef;

        if (!dialog.open) return false;

        setTimeout(() => {
            this.onCloseHandler();
        }, 30000);
    }

    handleProductAdded() {
        const { cart: { cartTotals: { items } } } = this.props;
        const { current: dialog } = this.dialogRef;

        if (!dialog.open && items.length === 1) {
            dialog.showModal();
        }

        this.closeAfterTimeout();
    }

    componentWillUnmount() {
        const { current: dialog } = this.dialogRef;

        if (dialog) {
            dialog.removeEventListener('click', this.clickOutsideHandler);
        }
    }

    getIsDisabled() {
        const { lbx_popups_enabled } = this.props;

        return String(lbx_popups_enabled) !== '1';
    }

    render() {
        if (this.getIsDisabled()) return null;

        return (
            <LbxPopupComponent ref={this.dialogRef} onCloseHandler={() => this.onCloseHandler()}>
                <LbxPopupFooter onCloseHandler={() => this.onCloseHandler()} />
                <LbxWrapper loader suffix="popup" />
            </LbxPopupComponent>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LbxPopupContainer);
